export class Organization {
  name = null;
  code = null;
  parentId = null;
  organizationType = null;
  isUsing = true;
  listDEx = [];
}